import PropertyEditor from './PropertyEditor';

export default PropertyEditor;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/PropertyEditor/index.js